import { render, staticRenderFns } from "./returnlist.vue?vue&type=template&id=1f5faeac&"
import script from "./returnlist.vue?vue&type=script&lang=js&"
export * from "./returnlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports